const REDUNDANT_PREFIXES = [
  /^Failed to send reminder:\s*/i,
  /^Failed to send reminder email:\s*/i,
  /^Failed to send consent reminder email\.?\s*/i,
  /^FirebaseError:\s*/i,
  /^functions\/[a-z-]+:\s*/i,
];

export function stripRedundantErrorPrefixes(message) {
  let cleaned = String(message || '').trim();
  let previous = '';
  while (cleaned !== previous) {
    previous = cleaned;
    for (const pattern of REDUNDANT_PREFIXES) {
      cleaned = cleaned.replace(pattern, '');
    }
  }
  return cleaned.trim();
}

export function getCallableErrorMessage(error) {
  if (!error) return 'Something went wrong. Please try again.';

  const details = error?.details;
  if (typeof details === 'string' && details.trim()) {
    return stripRedundantErrorPrefixes(details);
  }

  const code = String(error?.code || '');
  const rawMessage = stripRedundantErrorPrefixes(error?.message || '');

  if (code.includes('failed-precondition')) {
    if (/no patient email/i.test(rawMessage)) {
      return 'This patient does not have an email address on file.';
    }
    if (/no access token|no signing link/i.test(rawMessage)) {
      return 'This consent does not have a signing link yet. Try resending the consent instead.';
    }
    return rawMessage || 'This reminder cannot be sent for this consent.';
  }

  if (code.includes('permission-denied')) {
    return rawMessage || 'You do not have permission to send this reminder.';
  }

  if (code.includes('unauthenticated')) {
    return 'Your session has expired. Please sign in again.';
  }

  if (code.includes('unavailable')) {
    return rawMessage || 'Email delivery is temporarily unavailable. Please try again shortly.';
  }

  if (/no patient email/i.test(rawMessage)) {
    return 'This patient does not have an email address on file.';
  }

  if (/sender address rejected|authentication|smtp|econnrefused/i.test(rawMessage)) {
    return 'We could not deliver the email right now. Please try again in a few minutes.';
  }

  return rawMessage || 'Something went wrong. Please try again.';
}

export function getReminderSendErrorMessage(error) {
  return getCallableErrorMessage(error);
}
